'use client';

import React from 'react';
import { IdView } from '../../../../components';
import { RevshareCost } from '../types';

interface IdCellProps {
  cost: RevshareCost;
}

const IdCell: React.FC<IdCellProps> = ({ cost }) => {
  const idString = cost._id;

  return (
    <div className="flex items-center">
      <IdView textToCopy={idString}>{idString.slice(-4)}</IdView>
    </div>
  );
};

export default IdCell;
